import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HotelDistance(_ref) {
  var distance = _ref.distance,
    unit = _ref.unit,
    labels = _ref.labels,
    testId = _ref.testId,
    styles = _ref.styles;
  return _jsx(Text, _objectSpread(_objectSpread({}, styles), {}, {
    "data-testid": testId,
    children: getLabel(distance, unit, labels)
  }));
}
export function getLabel(distance, unit, labels) {
  var _labels$distanceUnitP;
  if (distance === 1 || unit === 'km') {
    return "".concat(distance, " ").concat(unit, " ").concat(labels.fromLocation);
  }
  return "".concat(distance, " ").concat((_labels$distanceUnitP = labels.distanceUnitPlural) === null || _labels$distanceUnitP === void 0 ? void 0 : _labels$distanceUnitP.toLowerCase(), " ").concat(labels.fromLocation);
}